import {runSafe, whenReady} from "../../../utils";
import {initDreamUniversityScales} from "./_initDreamUniversityScales";
import {initProgramsCounter} from "./_initProgramsCounter";

whenReady(() => {
  runSafe(() => {
    initDreamUniversityScales();
    initProgramsCounter();
  });
});